import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { DeleteIcon, EditIcon } from 'Icons';
import ButtonIcon from 'components/IconButton';
import AttendanceTrackingShiftForm from 'containers/Pages/People/Attendance/Layouts/attendanceTrackingShiftForm.jsx';
import { useTranslation } from 'react-i18next';

const RowEditing = ({ value }) => {
  const { t } = useTranslation();
  const [openForm, setOpenForm] = useState(false);

  const [editMode, setEditMode] = useState(false);
  const [deleteMode, setDeleteMode] = useState(false);

  const [editModeValues, setEditModeValues] = useState(null);
  const [deleteModeValues, setDeleteModeValues] = useState(null);

  const handleEdit = () => {
    setEditModeValues(value.itemData);
    setEditMode(true);
    setOpenForm(true);
  };

  const handleDelete = () => {
    setDeleteModeValues(value.itemData);
    setDeleteMode(true);
    setOpenForm(true);
  };

  const closeForm = () => {
    setEditModeValues(null);
    setDeleteModeValues(null);
    setEditMode(false);
    setDeleteMode(false);
    setOpenForm(false);
  };

  return (
    <>
      {value?.allowableActions?.allowEdit && (
        <ButtonIcon
          onClick={handleEdit}
          component={EditIcon}
          text={t('Edit')}
        />
      )}
      {value?.allowableActions?.allowDelete && (
        <ButtonIcon
          component={DeleteIcon}
          onClick={handleDelete}
          text={t('Delete')}
        />
      )}
      {openForm && (
        <AttendanceTrackingShiftForm
          closeForm={closeForm}
          editModeValues={editModeValues}
          editMode={editMode}
          deleteMode={deleteMode}
          deleteModeValues={deleteModeValues}
        />
      )}
    </>
  );
};

RowEditing.propTypes = {
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default RowEditing;
